// extracted by mini-css-extract-plugin
module.exports = {"block_container":"Resume_block_container__2YscT","info_container":"Resume_info_container__2gNzv","react_icon":"Resume_react_icon__5Udp-"};